import React from 'react';
import { Typography } from 'src/typography';
import { Sizes } from 'src/typography/types';
import styled, { css } from 'styled-components';

export type TabCalloutProps = {
  label: string;
  backgroundColor?: string;
  textColor?: string;
  textSize?: Sizes;
};

export const TabCallout = ({
  label,
  backgroundColor,
  textColor,
  textSize = 'xsmall',
}: TabCalloutProps): JSX.Element => (
  <Callout data-testid='tab-callout' $backgroundColor={backgroundColor}>
    <CalloutLabel size={textSize} weight='bold' $textColor={textColor}>
      {label}
    </CalloutLabel>
  </Callout>
);

const CalloutLabel = styled(Typography.Label)<{ $textColor?: string }>`
  color: ${({ $textColor, theme }) =>
    `var(--dcm-checkout-payment-tab-callout-text-color, ${$textColor ?? theme.colors.green90})`};
`;

const Callout = styled.div<{ $backgroundColor?: string }>`
  ${({ theme: { colors: themeColors }, $backgroundColor }) => {
    const background = $backgroundColor ?? themeColors.green20;

    return css`
      background: var(--dcm-checkout-payment-tab-callout-background, ${background});
      border-radius: var(--dcm-checkout-payment-tab-callout-border-radius, 8px 8px 0 0);
      padding: 4px 8px;
      text-align: center;
      z-index: 1;

      &::after {
        background-color: var(--dcm-checkout-payment-tab-callout-background, ${background});
        content: '';
        height: 20px;
        left: 0;
        position: absolute;
        top: 20px;
        width: 100%;
      }
    `;
  }}
`;
